import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SiNewtonLoadingService } from '@simpl/newton-ng/loading-spinner';
import { ProductPriceServiceService } from 'src/app/services/product-price-service.service';

@Component({
  selector: 'app-lss-legacy-system-service',
  templateUrl: './lss-legacy-system-service.component.html'
})
export class LssLegacySystemServiceComponent {
  @Input()
  public parentForm!: FormGroup;

  @Output()
  openHelpModal: EventEmitter<any> = new EventEmitter();

  selectedLssPackage!: string;

  // Price warnings for not available prices
  priceWarnings: string[] = [];

  constructor(
    private loadingSpinner: SiNewtonLoadingService,
    private productPriceService: ProductPriceServiceService
  ) {}

  async updateListPricesOfLssPackages() {
    this.loadingSpinner.startLoading();

    let componentsCommaSeperated = '';
    const notAvailableWarnings: string[] = [];

    for (let i = 7; i <= 9; i++) {
      componentsCommaSeperated += this.parentForm.get('legacySystemServiceForm')?.get('lssPackageV' + i + 'Mlfb')?.value + ',';
      componentsCommaSeperated += this.parentForm.get('legacySystemServiceForm')?.get('lssPackageV' + i + 'ExtensionMlfb')?.value + ',';
    }

    const priceMflbList = (await this.productPriceService.getCurrentPricesByMlfbList(componentsCommaSeperated.replace(/.$/, ''))) as any;

    for (let i = 7; i <= 9; i++) {
      const mlfb = this.parentForm.get('legacySystemServiceForm')?.get('lssPackageV' + i + 'Mlfb')?.value;
      const curListPriceForMlfb = this.parentForm.get('legacySystemServiceForm')?.get('lssPackageV' + i + 'LPrice')?.value;

      const extensionMlfb = this.parentForm.get('legacySystemServiceForm')?.get('lssPackageV' + i + 'ExtensionMlfb')?.value;
      const curListPriceForExtensionMlfb = this.parentForm
        .get('legacySystemServiceForm')
        ?.get('lssPackageV' + i + 'ExtensionLPrice')?.value;

      // Handle main MLFB price update
      if (mlfb && priceMflbList[mlfb] !== undefined) {
        const price = priceMflbList[mlfb];
        const priceString = price?.toString().toLowerCase();

        // Check if price is "not available" (case-insensitive)
        const isNotAvailable =
          priceString === 'not available' ||
          priceString === 'notavailable' ||
          priceString === 'not_available' ||
          priceString === 'n/a' ||
          priceString === 'na';

        if (isNotAvailable) {
          notAvailableWarnings.push(`${mlfb}: Price not available`);
        } else if (price !== curListPriceForMlfb) {
          const numericPrice = parseFloat(price);
          if (!isNaN(numericPrice)) {
            if (numericPrice === 0) {
              notAvailableWarnings.push(`${mlfb}: Component not found`);
            } else {
              const curFormControl = this.parentForm.get('legacySystemServiceForm')!.get('lssPackageV' + i + 'LPrice')!;
              curFormControl.setValue(numericPrice);
              curFormControl.markAsDirty();
              curFormControl.markAsUntouched();
            }
          } else {
            notAvailableWarnings.push(`${mlfb}: Invalid price format`);
          }
        }
      } else if (mlfb) {
        notAvailableWarnings.push(`${mlfb}: Price not found in response`);
      }

      // Handle extension MLFB price update
      if (extensionMlfb && priceMflbList[extensionMlfb] !== undefined) {
        const price = priceMflbList[extensionMlfb];
        const priceString = price?.toString().toLowerCase();

        // Check if price is "not available" (case-insensitive)
        const isNotAvailable =
          priceString === 'not available' ||
          priceString === 'notavailable' ||
          priceString === 'not_available' ||
          priceString === 'n/a' ||
          priceString === 'na';

        if (isNotAvailable) {
          notAvailableWarnings.push(`${extensionMlfb}: Price not available`);
        } else if (price !== curListPriceForExtensionMlfb) {
          const numericPrice = parseFloat(price);
          if (!isNaN(numericPrice)) {
            if (numericPrice === 0) {
              notAvailableWarnings.push(`${extensionMlfb}: Component not found`);
            } else {
              const curFormControl = this.parentForm.get('legacySystemServiceForm')!.get('lssPackageV' + i + 'ExtensionLPrice')!;
              curFormControl.setValue(numericPrice);
              curFormControl.markAsDirty();
              curFormControl.markAsUntouched();
            }
          } else {
            notAvailableWarnings.push(`${extensionMlfb}: Invalid price format`);
          }
        }
      } else if (extensionMlfb) {
        notAvailableWarnings.push(`${extensionMlfb}: Price not found in response`);
      }
    }

    // Update warnings for frontend display
    if (notAvailableWarnings.length > 0) {
      this.priceWarnings = notAvailableWarnings;
      console.warn('LSS price warnings found:', notAvailableWarnings);
    } else {
      this.priceWarnings = [];
    }

    this.loadingSpinner.stopLoading();
  }
}
